const TodoHistoryTypes = {
  MESSAGE: 'message',
  STATUS: 'status',
}

export default Object.freeze(TodoHistoryTypes)
